<ng-container *ngIf="ready == false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="ready">
  <convfact-advancepayment-form [advancePayment]="advancePayment" [concepts]="concepts" [errors]="errors"
    [accountsAndTaxes]="accountsAndTaxes" [bankAccounts]="bankAccounts" [paymentCards]="paymentCards"
    (onSave)="saveData($event)"></convfact-advancepayment-form>
</ng-container>
